import { ROUTES } from '@ab-core/functions';
import {
    ChangeLogCard,
    isVisibleChangeLog
} from '@ab-core/gatsby-theme-core/src/scopes/changeLog/components/changeLogCards';
import {
    isChangeLogUnread,
    setChangeLogRead
} from '@ab-core/gatsby-theme-core/src/scopes/changeLog/components/changeLogRead';
import { getChangeLog } from '@ab-core/gatsby-theme-core/src/scopes/changeLog/components/getChangeLog';
import Modal from '@ab-core/modal';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';

type ChangeLogNode = Queries.ContentfulChangeLogGroupConnection['nodes'][number];

export const NewsModal: FC = () => {
    const allContentfulChangeLog = getChangeLog();
    const [unreadNews, setUnreadNews] = useState<Array<ChangeLogNode>>([]);
    const [open, setOpen] = useState(false);

    const currentRoute = typeof window === 'undefined' ? '' : location.pathname;

    useEffect(() => {
        const userIsLoggedIn = Boolean(localStorage.getItem('isLoggedIn'));
        const isCypressTest = Boolean(localStorage.getItem('isCypressTest'));
        const isChangeLogPage = currentRoute.includes(ROUTES.CHANGELOG);

        if (!userIsLoggedIn || isCypressTest || isChangeLogPage) {
            setOpen(false);

            return;
        }

        const news = (allContentfulChangeLog?.nodes || []).filter(
            (changelog) => isVisibleChangeLog(changelog) && isChangeLogUnread(changelog?.createdAt)
        );

        setUnreadNews(news);
        setOpen(news.length > 0);
    }, [allContentfulChangeLog, currentRoute]);

    const closeModal = () => {
        setChangeLogRead();
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={closeModal} headerText="Neuigkeiten">
            <div className="flex-direction-column gap-small2">
                {unreadNews.map((changelog) => (
                    <ChangeLogCard key={changelog.id} changelog={changelog} />
                ))}
            </div>
        </Modal>
    );
};
